export default {
	yandex: 'yandex',
	kinohod: 'kinohod',
	rambler: 'rambler'
};
